import React from 'react';
import { useDroppable } from '@dnd-kit/core';

const DroppableCategory = ({ id, children, className, onDoubleClick }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  return (
    <div
      ref={setNodeRef}
      onDoubleClick={onDoubleClick}
      className={`${className} ${isOver ? 'ring-4 ring-slate-400 ring-opacity-50' : ''} transition-all cursor-pointer`}
    >
      {children}
    </div>
  );
};

export default DroppableCategory;
